var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_394_386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 2,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5894 9.362C18.2036 10.7477 14.9512 13.9995 14.1579 14.7902C13.9865 14.9609 13.7825 15.0959 13.5635 15.1839C12.9273 15.4478 11.3754 16.0566 10.9191 16.0872C10.6473 16.1055 10.3808 16.0051 10.1878 15.8122C9.99489 15.6193 9.89451 15.3527 9.91276 15.0809C9.9434 14.6246 10.5522 13.074 10.8116 12.4404C10.9022 12.2156 11.0371 12.0116 11.2085 11.8408L16.638 6.41066C16.9007 6.14799 17.2579 6.00003 17.6294 6.00003C18.0009 6.00003 18.3581 6.14799 18.6208 6.41066L19.5894 7.37923C19.852 7.64191 20 7.99909 20 8.37062C20 8.74214 19.852 9.09933 19.5894 9.362ZM10.8924 15.1076C11.3382 15.0515 12.6412 14.5079 13.1887 14.2805C13.1907 14.2798 13.1926 14.2792 13.1939 14.2785C13.2962 14.2374 13.3888 14.1762 13.4664 14.0986L13.467 14.098C14.2616 13.3073 17.5127 10.0562 18.8978 8.67044C18.9773 8.59092 19.0223 8.48338 19.0223 8.37062C19.0223 8.25786 18.9773 8.15031 18.8978 8.07079L17.9292 7.10222C17.8497 7.0227 17.7422 6.97773 17.6294 6.97773C17.5166 6.97773 17.4091 7.0227 17.3296 7.10222L11.8994 12.5323C11.8212 12.6099 11.76 12.7031 11.7189 12.8054L11.7176 12.8081C11.4927 13.3569 10.9485 14.6611 10.8924 15.1076Z",
    fill: "#7509B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2982 9.96164C18.4885 10.1526 18.4885 10.4622 18.2982 10.6532C18.1072 10.8442 17.7976 10.8442 17.6066 10.6532L15.3468 8.39341C15.1559 8.20244 15.1559 7.89283 15.3468 7.70186C15.5378 7.51153 15.8474 7.51153 16.0384 7.70186L18.2982 9.96164Z",
    fill: "#7509B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3085 13.9513C14.4995 14.1416 14.4995 14.4519 14.3085 14.6422C14.1182 14.8332 13.8079 14.8332 13.6176 14.6422L11.3578 12.3824C11.1669 12.1921 11.1669 11.8818 11.3578 11.6915C11.5482 11.5005 11.8584 11.5005 12.0487 11.6915L14.3085 13.9513Z",
    fill: "#7509B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7255 7.28995C10.9954 7.28995 11.2144 7.50895 11.2144 7.7788C11.2144 8.04864 10.9954 8.26764 10.7255 8.26764H8.44424C7.63406 8.26764 6.9777 8.924 6.9777 9.73419V17.5558C6.9777 17.9449 7.13217 18.3177 7.40723 18.5928C7.68229 18.8678 8.05512 19.0223 8.44424 19.0223H16.9176C17.3067 19.0223 17.6796 18.8678 17.9546 18.5928C18.2297 18.3177 18.3842 17.9449 18.3842 17.5558V15.2745C18.3842 15.0046 18.6032 14.7856 18.873 14.7856C19.1429 14.7856 19.3619 15.0046 19.3619 15.2745V17.5558C19.3619 18.2043 19.1044 18.8255 18.6462 19.2843C18.1873 19.7425 17.5662 20 16.9176 20H8.44424C7.7957 20 7.17454 19.7425 6.71567 19.2843C6.25746 18.8255 6 18.2043 6 17.5558V9.73419C6 8.38431 7.09437 7.28995 8.44424 7.28995H10.7255Z",
    fill: "#7509B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_394_386",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_394_386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_394_386",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.eff75a208c7fa8bf563903f077a1ef51.svg";
export { ForwardRef as ReactComponent };